export default "__VITE_ASSET__Btc$gsvr__"